import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const Transition = props => <Slide direction="up" {...props} />;

const ListDialog = ({ title, items, onClose, ...other }) => (
  <Dialog
    aria-labelledby="list-dialog-title"
    classes={{ paper: 'h-full' }}
    fullWidth
    onClose={onClose}
    TransitionComponent={Transition}
    {...other}
  >
    <AppBar position="static">
      <Toolbar>
        <Typography
          id="list-dialog-title"
          variant="h6"
          color="inherit"
          className="flex-grow"
        >
          {title}
        </Typography>
        <IconButton color="inherit" onClick={onClose} aria-label="Close">
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
    <DialogContent>
      <List>
        {items.map(item => (
          <ListItem key={item}>
            <ListItemText
              primary={`\u2022 ${item}`}
              primaryTypographyProps={{ variant: 'body1' }}
            />
          </ListItem>
        ))}
      </List>
    </DialogContent>
  </Dialog>
);

export default withMobileDialog()(ListDialog);
